// extracted by mini-css-extract-plugin
export default {"widget":"widget--Ga0_k","delimiter":"delimiter--gVyie"};